import { render, staticRenderFns } from "./CahtPt.vue?vue&type=template&id=6d823d18&scoped=true&"
import script from "./CahtPt.vue?vue&type=script&lang=js&"
export * from "./CahtPt.vue?vue&type=script&lang=js&"
import style0 from "./CahtPt.vue?vue&type=style&index=0&id=6d823d18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d823d18",
  null
  
)

export default component.exports